<template>
  <family-page-wrapper class="family-grocery-lists">
    <grocery-list-search
      ref="groceryListSearchRef"
      @edit="onEditList"
      @create="onCreateList"
    />
    <grocery-list-editor
      v-if="editorState.isVisible"
      :list="editorState.list"
      :caller-id="editorState.callerId"
      @refresh="onRefresh"
      @saved="onEditorSaved"
      @cancel="closeEditor"
    />
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { reactive, ref, defineAsyncComponent } from 'vue';
import type { GroceryList } from '@/services/groceryList/fetchGroceryLists';

const GroceryListSearch = defineAsyncComponent(
  () => import('../Operator/Grocery/GroceryListBuilder/GroceryListSearch.vue') as any,
);

const GroceryListEditor = defineAsyncComponent(
  () => import('../Operator/Grocery/GroceryListBuilder/GroceryListEditor.vue') as any,
);

interface GroceryListSearchRef {
  refreshGroceryLists: () => Promise<void>;
}

const groceryListSearchRef = ref<GroceryListSearchRef | null>(null);

const editorState = reactive<{
  isVisible: boolean;
  list: GroceryList | null;
  callerId: string;
}>({
  isVisible: false,
  list: null,
  callerId: '',
});

const onEditList = (list: GroceryList) => {
  editorState.isVisible = true;
  editorState.list = list;
  editorState.callerId = list.callerId;
};

const onCreateList = (callerId: string) => {
  editorState.isVisible = true;
  editorState.list = null;
  editorState.callerId = callerId;
};

const closeEditor = () => {
  editorState.isVisible = false;
  editorState.list = null;
};

const onRefresh = () => {
  groceryListSearchRef.value?.refreshGroceryLists();
};
const onEditorSaved = () => {
  closeEditor();
};
</script>
